// extracted by mini-css-extract-plugin
export var box = "_7y-1";
export var checkboxRow = "_7y-8";
export var checked = "_7y-2";
export var descriptionSpacer = "_7y-a";
export var disabled = "_7y-3";
export var icon = "_7y-6";
export var input = "_7y-0";
export var labelSpacer = "_7y-9";
export var medium = "_7y-5";
export var small = "_7y-4";
export var text = "_7y-7";